import imagesLoaded from "imagesloaded";
import Isotope from "isotope-layout";
import {applyEqualHeightFitRowsPatch} from "./equal_height_fit-rows";
function initIsotope() {
    const filterGroups = document.querySelectorAll('.js-filter-btn-group'); // Korrigierter Selektor

    for (const filterGroup of filterGroups) {
        const grid = filterGroup.nextElementSibling; // Assuming the grid is the next sibling
        const filters = {};

        // Wait for images to load before Isotope initialization
        imagesLoaded(grid, () => {
            const isotope = new Isotope(grid, {
                layoutMode: 'fitRows',
                itemSelector: '.grid-item', // Korrigierter Selektor
                percentPosition: true,
                fitRows: {
                    equalheight: true
                }
            });

            filterGroup.addEventListener('click', (event) => {
                const button = event.target;
                if (!button.matches('button')) return; // Only handle button clicks

                const buttonGroup = button.closest('.js-filter-btn-group');
                const filterButtonGroup = buttonGroup.dataset.filterGroup;
                filters[filterButtonGroup] = button.dataset.filter;

                const filterValue = concatValues(filters);
                isotope.arrange({ filter: filterValue });

                // No Results if no filterItem is present
                const filteredItems = isotope.getFilteredItemElements();
                const noResults = document.querySelector('.filter-no-results'); // Korrigierter Selektor
                if (noResults) { // Überprüfen, ob das Element existiert
                    if (filteredItems.length === 0) {
                        noResults.classList.remove('d-none'); // Show no results element
                    } else {
                        noResults.classList.add('d-none'); // Hide no results element
                    }
                }
            });

            const buttonGroups = document.querySelectorAll('.js-filter-btn-group');
            for (const buttonGroup of buttonGroups) {
                buttonGroup.addEventListener('click', (event) => {
                    const button = event.target;
                    if (!button.matches('button')) return; // Only handle button clicks

                    const activeButton = buttonGroup.querySelector('.active');
                    if (activeButton) activeButton.classList.remove('active');
                    button.classList.add('active');
                });
            }
        });
    }
}

function masonryLayout() {
    var masonryLayout = document.querySelector('.js-layout-masonry');

    if (masonryLayout) {
        var iso = new Isotope(masonryLayout, {
            itemSelector: '.grid-item', // Wähle die einzelnen Grid-Elemente aus
            percentPosition: true, // Ermöglicht prozentuale Breiten für responsive Layouts
            masonry: {
                columnWidth: '.gutter-sizer', // Definiert die Spaltenbreite basierend auf dem gutter-sizer Element
                gutter: 0 // Optional: Setze den Abstand zwischen den Spalten auf 0, falls gewünscht
            }
        });

        // Optional: Isotope nach dem Laden von Bildern neu anordnen, um Lücken zu vermeiden
        imagesLoaded(masonryLayout).on('progress', function() {
            iso.layout();
        });
    }
}
// Function to flatten object by concatenating values (similar to original)
function concatValues(obj) {
    let value = '';
    for (const prop in obj) {
        value += obj[prop];
    }
    return value;
}

function filterCheckAndReduce() {
    const fExperts = document.querySelectorAll('.js-filter-check-reduce');

    for (const fExpert of fExperts) {
        var iso = new Isotope(fExpert, {
            itemSelector: '.grid-item',
            percentPosition: true,
            layoutMode: 'fitRows',
            fitRows: {
                //equalheight: true
            }
        });

        var filters = '';
        var filter_links = document.querySelectorAll('#dfg1 > button, #dfg2 > button');
        for (var i = 0; i < filter_links.length; i++) {
            filter_links[i].addEventListener('click', function (e) {
                e.preventDefault();
                var filterItem = e.target.dataset.filter;
                if (filterItem === 'clear') {
                    if (e.target.parentNode.id === 'dfg1') {
                        var active_links = document.querySelectorAll('#dfg1 .active');
                    } else if (e.target.parentNode.id === 'dfg2') {
                        var active_links = document.querySelectorAll('#dfg2 .active');
                    } else {
                        var active_links = '';
                    }
                    for (var j = 0; j < active_links.length; j++) {
                        filters = filters.replace('.' + active_links[j].dataset.filter, '');
                        active_links[j].classList.remove('active');
                    }
                    active_links = document.querySelectorAll('.filter-group .active, .js-filter-check-reduce .active');
                    for (var j = 0; i < active_links.length; j++) {
                        filters += '.' + active_links[j].dataset.filter;
                        iso.arrange({
                            filter: function () {
                                return filters
                            }()
                        });
                    }
                } else if (filters.indexOf(filterItem) <= 0) {
                    if (filters.length > 0) {
                        filters += '.' + filterItem;
                    } else {
                        filters = '.' + filterItem;
                    }
                    e.target.className = e.target.className + ' active';
                } else {
                    e.target.className = e.target.className.replace(/active/gi, '');
                    if (filters.length > 0) {
                        filters = filters.replace('.' + filterItem, '');
                    } else {
                        filters = '';
                    }
                }

                iso.arrange({
                    filter: function () {
                        return filters
                    }()
                });

                // No Results if no filterItem is present
                const noResults = document.querySelector('.filter-no-results');
                const hasResults = document.querySelector('.filter-has-results');
                const filterItemCount = iso.getFilteredItemElements().length;
                console.log(filterItemCount)
                if (filterItemCount === 0) {
                    noResults.classList.remove('d-none'); // Show no results element
                    hasResults.classList.add('d-none'); // Hide has results element
                } else {
                    noResults.classList.add('d-none'); // Hide no results element
                    hasResults.classList.remove('d-none'); // Show has results element
                }
                console.log(iso.getFilteredItemElements());
            });
        }
    }
}

function postFilter() {
        const buttonFilters = {};
        let buttonFilter;
        const optionFilters = {};
        let optionFilter;
        let qsRegex;

        const filterContainers = document.querySelectorAll('.filter');

        filterContainers.forEach(filterContainer => {
            const grid = filterContainer.nextElementSibling;
            imagesLoaded(grid, function () {
            const iso = new Isotope(grid, {
                layoutMode: 'fitRows',
                itemSelector: '.grid-item',
                percentPosition: true,
                fitRows: {equalheight: true},
                filter: function (itemElem) {
                    const searchText = itemElem.textContent;
                    const searchResult = qsRegex ? qsRegex.test(searchText) : true;
                    const buttonResult = buttonFilter ? itemElem.matches(buttonFilter) : true;
                    const optionResult = optionFilter ? itemElem.matches(optionFilter) : true;
                    return searchResult && buttonResult && optionResult;
                },
            });
            // FIX: Nach jedem Filtern das Layout erneut triggern
            iso.on('arrangeComplete', function() {
                iso.layout();
            });

            const filterGroups = filterContainer.querySelectorAll('.filter-group');
            filterGroups.forEach(group => {
                group.addEventListener('click', function (e) {
                    if (e.target.tagName === 'BUTTON') {
                        const button = e.target;
                        const buttonGroup = button.closest('.btn-group');
                        const filterGroup = buttonGroup.getAttribute('data-filter-group');
                        let val = button.getAttribute('data-filter');
                        buttonFilters[filterGroup] = val === '*' ? '' : val;
                        buttonFilter = concatValues(buttonFilters);
                        iso.arrange();
                    }
                });
            });

            const searchInput = filterContainer.querySelector('.quicksearch');
            if (searchInput) {
                searchInput.addEventListener('keyup', debounce(function () {
                    qsRegex = new RegExp(searchInput.value, 'gi');
                    iso.arrange();
                }));
            }

            const selectFilters = filterContainer.querySelectorAll('.filters-select');
            selectFilters.forEach(select => {
                select.addEventListener('change', function (e) {
                    const filterGroup = select.getAttribute('value-group');
                    optionFilters[filterGroup] = e.target.value;
                    optionFilter = concatValues(optionFilters);
                    iso.arrange();
                });
            });

            // is-checked class toggle
            const btnGroups = filterContainer.querySelectorAll('.btn-group');
            btnGroups.forEach(group => {
                group.addEventListener('click', function (e) {
                    if (e.target.tagName === 'BUTTON') {
                        const checked = group.querySelector('.is-checked');
                        if (checked) checked.classList.remove('is-checked', 'active');
                        e.target.classList.add('is-checked', 'active');
                    }
                });
            });

            function concatValues(obj) {
                return Object.values(obj).join('');
            }

            function debounce(fn, threshold = 100) {
                let timeout;
                return function (...args) {
                    clearTimeout(timeout);
                    timeout = setTimeout(() => fn.apply(this, args), threshold);
                };
            }

        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    applyEqualHeightFitRowsPatch(Isotope);
    initIsotope();
    //filterCheckAndReduce();
    postFilter();
    //masonryLayout();
});
